import { Component, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';
import { TaskDataService,  } from '../../../shared/services/task-data.service';
import { ITaskBorrowerDrawData, ITaskRequest, TaskBorrowerDrawData, TaskRequest } from '../../../modules/tasks/model/types';
import notify from 'devextreme/ui/notify';
import validationEngine from "devextreme/ui/validation_engine";
import { TreasuryDataService } from '../../../shared/services/treasury-data.service';

import {  getNotificationTimeout, sendNotificationMessage } from '../../../types/resource';
import { LoggingService } from '../../../framework/logging/logging.service';
import { SeverityLevel } from '../../../framework/logging/severity-level.model';
import { BehaviorSubject, lastValueFrom } from 'rxjs';
import { StaticDataService } from '../../../shared/services/static-data.service';

import { ProfileDataService } from '../../../shared/services/profile-data.service';
import { MessageService } from '../../../shared/components/framework/services/message.service';
import { FormUtils } from '../../../shared/components/framework/services/form-builder.service';
import { LoanDataBase } from '../baseclass/loandata-base';
import { UtilService } from '../../../shared/services/util.service';


@Component({
  selector: 'app-borrower-draw-request',
  templateUrl: './borrower-draw-request.component.html',
  styleUrl: './borrower-draw-request.component.scss'
})
export class BorrowerDrawRequestComponent extends LoanDataBase {
  @ViewChild('formElement') formElement!: ElementRef;

  @Input() taskTemplateName: string;
  @Input() task: ITaskRequest;
  @Output() onAddNewTaskEventEmitter: EventEmitter<any> = new EventEmitter();

  currentFormInstance: any = null;
  mandatoryFiles: boolean = false;
  override showInactiveLoans: boolean = false;
  formItemsBehaviourSubject$ = new BehaviorSubject<any[]>([]);
  formItems$ = this.formItemsBehaviourSubject$.asObservable();
  formColCountBehaviourSubject$ = new BehaviorSubject<number>(2);
  formColCount$ = this.formColCountBehaviourSubject$.asObservable();
  isUrgent: boolean = false;
  currentRequestType: string = "";
  formColCount: number = 2;
  requestTypes: any[];
  bankData: any[];
  requestData:  any = {};
  billableToClientData: any[];
  isLoading: boolean = false;
  businessDayCalendars: any[];
  files: File[] = [];
  directors: any[];
  seniorDirectors: any[];
  today: Date = new Date();
  isEditable:  boolean = false;
  allUsers: any[];
  formItems: any[] = [];
  isInvoiceBorrowerChecked: boolean = false;
  isInvoiceClientChecked: boolean = false;
  isInvoiceNoneChecked: boolean = false;
  invoice: string = '';
  private isUpdatingInvoiceCheckboxes: boolean = false;

  constructor(taskDataService: TaskDataService,
    private readonly messageService: MessageService,
    private readonly profileDataService: ProfileDataService,
    private readonly loggingService: LoggingService,
    private readonly utilService: UtilService) {
    super(taskDataService);
    this.onRequestTypeSelectionChanged =
      this.onRequestTypeSelectionChanged.bind(this);
    this.formItems$.subscribe((items: any[]) => {
      this.formItems = items;
    });

    this.formColCount$.subscribe((colcount: number) => {
      this.formColCount = colcount;
    });
    // Subscribe to loan data changes and refresh form configuration
    this.loanNumbers$.subscribe((data) => {
      // Always update the local loanNumbers property
      this.loanNumbers = data;
      this.updateLoanDataInFormConfig();
    });
  }

  private updateLoanDataInFormConfig(): void {
    if (!this.currentFormInstance) {
      return;
    }
    const loanEditor = this.currentFormInstance.getEditor('loanNumber');
    if (loanEditor) {
      loanEditor.option('items', this.loanNumbers);
    }
  }

  onFileUpload(file: File) {
    this.files.push(file);
  }

  onFileRemove(file: File) {
    if(file != null && file != undefined)
    {
      this.files = this.files.filter(f => f !== file);
    }
  }

  onValidateVoucherAmount(e: any) {
    if(e.value == null || e.value <= 0)
      return false;
    return true;
  }

  async getUserData() {
    try{
      const data = await lastValueFrom(this.profileDataService.getAllUsers(false));
      this.allUsers = data[1].map(item => ({ id: item.id, name: item.firstName + ' ' + item.lastName }));
    }
    catch(err: any)
    {
      this.loggingService.logError(err, SeverityLevel.Error);
      notify(err.message, 'error', this.utilService.getNotificationTimeout());
    }
  }
  onFormContentReady(e: any): void {
    this.currentFormInstance = e.component;
  }

  onRequestTypeSelectionChanged(e: any) {
    // Safety check for selectedItem
    if (!e.selectedItem || !e.selectedItem.name) {
      console.warn('Invalid selection event:', e);
      return;
    }
    this.currentRequestType = e.selectedItem.name;
    this.requestData.requestType = e.selectedItem.name;
    let config = [];
    switch (e.selectedItem.name.toUpperCase()) {
    case "LOAN DRAW":
    case "RESERVE DRAW":
      this.mandatoryFiles = !this.isEditable;
      config = [
        {
          dataField: "requestType",
          editorType: "dxTextBox",
          label: { text: "Request Type" },
          colSpan: 2,
          cssClass: "dx-widget",
          editorOptions: { value: e.selectedItem.name, readOnly: true, required: "true" },
          validationRules: [
            { type: "required", message: "Request Type is required" },
          ],
        },
        {
          itemType: "group",
          colCount: 4,
          colSpan: 2,
          items: [
            {
              labelMode: "static",
              dataField: "loanNumber",
              editorType: "dxSelectBox",
              colSpan: 3,
              cssClass: "dx-widget",
              label: { text: "Loan Number" },
              editorOptions: {
                items: this.loanNumbers,
                valueExpr: "name",
                displayExpr: "name",
                required: true,
                searchMode: "contains",
                searchEnabled: true,
                itemTemplate: this.loanItemTemplate,
              },
              validationRules: [
                { type: "required", message: "Loan Number is required" },
              ],
            },
            {
              editorType: "dxCheckBox",
              label: { visible: false },
              cssClass: "loan-checkbox-center-align",
              editorOptions: {
                text: this.activeLoanCheckboxText,
                onValueChanged: this.onShowInactiveLoansChanged,
                value: this.showInactiveLoans,
              },
            },
          ],
        },
        {
          dataField: "drawNumber",
          editorType: "dxTextBox",
          label: { text: "Draw Number" },
          colSpan: 1,
          colcount: 2,
          cssClass: "dx-widget",
          editorOptions: { required: "true", defaultValue: "" },
          validationRules: [
            { type: "required", message: "Draw Number is required" },
          ],
        },
        {
          dataField: "dateFunded",
          editorType: "dxDateBox",
          label: { text: "Date Funded" },
          colcount: 2,
          colSpan: 1,
          cssClass: "dx-widget",
          // editorOptions: { max: this.today },
        },
        {
          dataField: "dateReceived",
          editorType: "dxDateBox",
          label: { text: "Date Received" },
          colcount: 2,
          colSpan: 1,
          cssClass: "dx-widget",
          // editorOptions: { max: this.today },
        },
        {
          dataField: "monthBilledToClient",
          editorType: "dxTextBox",
          label: { text: "Month Billed To Client" },
          colcount: 2,
          colSpan: 1,
          cssClass: "dx-widget",
          // editorOptions: { max: this.today },
        },
        {
          itemType: "group",
          colCount: 3,
          colSpan: 2,
          items: [
            {
              dataField: "invoiceBorrower",
              editorType: "dxCheckBox",
              label: { text: "Invoice Borrower" },
              colSpan: 1,
              cssClass: "dx-widget",
              editorOptions: {
                value: this.isInvoiceBorrowerChecked,
                onValueChanged: (e) => this.onInvoiceGroupCheckboxChanged(e, 'borrower')
              },
            },
            {
              dataField: "invoiceClient",
              editorType: "dxCheckBox",
              label: { text: "Invoice Client" },
              colSpan: 1,
              cssClass: "dx-widget",
              editorOptions: {
                value: this.isInvoiceClientChecked,
                onValueChanged: (e) => this.onInvoiceGroupCheckboxChanged(e, 'client')
              },
            },
            {
              dataField: "invoiceNone",
              editorType: "dxCheckBox",
              label: { text: "No Invoice" },
              colSpan: 1,
              cssClass: "dx-widget",
              editorOptions: {
                value: this.isInvoiceNoneChecked,
                onValueChanged: (e) => this.onInvoiceGroupCheckboxChanged(e, 'none')
              },
            },
            {
              // Validation proxy field - hidden but validates the group
              dataField: "invoiceValidationProxy",
              colSpan: 3,
              itemType: "simple",
              label: { visible: false },
              editorType: "dxTextBox",
              editorOptions: {
                visible: false,
                value: '',
              },
              validationRules: [
                {
                  type: "custom",
                  message: "At least one invoice option must be selected",
                  validationCallback: (e) => this.validateInvoiceGroup(e),
                  reevaluate: true,
                },
              ],
            },
          ]
        },
        {
          itemType: "group",
          colCount: 1,
          colSpan: 2,
          items: [
            {
              dataField: "drawFee",
              editorType: "dxNumberBox",
              label: { text: "Draw Fee" },
              colSpan: 1,
              cssClass: "dx-widget",
              editorOptions: {
                min: 0,
                step: 0.01,
                format: {
                  type: "currency",
                  currency: "USD",
                  precision: 2
                },
                disabled: !this.isInvoiceBorrowerChecked && !this.isInvoiceClientChecked,
              },
              validationRules: [
                {
                  type: "custom",
                  reevaluate: true,
                  validationCallback: (e) => {
                    // Only validate if invoice borrower or client is selected
                    if (this.isInvoiceBorrowerChecked || this.isInvoiceClientChecked) {
                      return e.value != null && e.value > 0;
                    }
                    return true;
                  },
                  message: "Draw Fee is required and must be greater than 0 when invoicing"
                }
              ]
            },
          ]
        },
        {
          itemType: "group",
          colCount: 4,
          colSpan: 2,
          items: [
            {
              labelMode: "static",
              dataField: "responsiblePersonId",
              editorType: "dxSelectBox",
              colSpan: 4,
              cssClass: "dx-widget",
              label: { text: "Responsible Person *" },
              editorOptions: {
                items: this.allUsers,
                valueExpr: "id",
                displayExpr: "name",
                required: false,
                searchMode: "contains",
                searchEnabled: true,
                onValueChanged: (e) => {
                  if (e.value) {
                    const selectedUser = this.allUsers.find(u => u.id === e.value);
                    if (selectedUser) {
                      this.requestData.responsiblePerson = selectedUser.name;
                      this.requestData.responsiblePersonId = selectedUser.id;
                    }
                  }
                },
              },
            },
          ],
          validationRules: [
            { type: "required", message: "Responsible Person is required" },
          ],
        },
        {
          itemType: "group",
          colCount: 4,
          colSpan: 2,
          items: [
            {
              labelMode: "static",
              dataField: "responsibleReviewerId",
              editorType: "dxSelectBox",
              colSpan: 4,
              cssClass: "dx-widget",
              label: { text: "Responsible Reviewer *" },
              editorOptions: {
                items: this.allUsers,
                valueExpr: "id",
                displayExpr: "name",
                required: false,
                searchMode: "contains",
                searchEnabled: true,
                onValueChanged: (e) => {
                  if (e.value) {
                    const selectedUser = this.allUsers.find(u => u.id === e.value);
                    if (selectedUser) {
                      this.requestData.responsibleReviewer = selectedUser.name;
                      this.requestData.responsibleReviewerId = selectedUser.id;
                    }
                  }
                },
              },
            },
          ],
          validationRules: [
            { type: "required", message: "Responsible Reviewer is required" },
          ],
        },
        {
          colSpan: 2,
          horizontalAlignment: "center",
          itemType: "simple",
          name: "fileUpload",
          label: {
            text: this.mandatoryFiles ? "Upload Files *" : "Upload Files",
          },
          template: "fileUploadTemplate",
        },
        {
          // work around to bind file upload component to form and validate it
          dataField: "fileUploadProxy",
          colSpan: 2,
          itemType: "simple",
          label: { visible: false },
          editorType: "dxTextBox",
          editorOptions: {
            visible: false,
            value: this.files.length.toString(),
          },
          validationRules: [
            {
              type: "custom",
              message: "At least one file is required",
              validationCallback: (e) => this.onValidateFileAttachments(e),
              reevaluate: true,
            },
          ],
        },
        {
          colSpan: 2,
          horizontalAlignment: "center",
          cssClass: "borrow-submit",
          editorType: "dxButton",
          editorOptions: { text: "Submit", useSubmitBehavior: true },
        },
      ];
      break;
    default:
      this.mandatoryFiles = !this.isEditable;
      config = [
        {
          dataField: "requestType",
          editorType: "dxTextBox",
          label: { text: "Request Type" },
          colSpan: 2,
          cssClass: "dx-widget",
          editorOptions: { value: e.selectedItem.name, readOnly: true, required: "true" },
          validationRules: [
            { type: "required", message: "Request Type is required" },
          ],
        },
        {
          itemType: "group",
          colCount: 4,
          colSpan: 2,
          items: [
            {
              labelMode: "static",
              dataField: "loanNumber",
              editorType: "dxSelectBox",
              colSpan: 3,
              cssClass: "dx-widget",
              label: { text: "Loan Number" },
              editorOptions: {
                items: this.loanNumbers,
                valueExpr: "name",
                displayExpr: "name",
                required: true,
                searchMode: "contains",
                searchEnabled: true,
                itemTemplate: this.loanItemTemplate,
              },
            },
            {
              editorType: "dxCheckBox",
              label: { visible: false },
              cssClass: "loan-checkbox-center-align",
              editorOptions: {
                text: this.activeLoanCheckboxText,
                onValueChanged: this.onShowInactiveLoansChanged,
                value: this.showInactiveLoans,
              },
            },
          ],
          validationRules: [
            { type: "required", message: "Loan Number is required" },
          ],
        },
        {
          dataField: "drawNumber",
          editorType: "dxTextBox",
          label: { text: "Draw Number" },
          colSpan: 2,
          cssClass: "dx-widget",
          editorOptions: { required: "true", defaultValue: "" },
          validationRules: [
            { type: "required", message: "Draw Number is required" },
          ],
        },
        {
          dataField: "dateFunded",
          editorType: "dxDateBox",
          label: { text: "Date Funded" },
          colSpan: 2,
          cssClass: "dx-widget",
          // editorOptions: { max: this.today },
        },
        {
          dataField: "dateReceived",
          editorType: "dxDateBox",
          label: { text: "Date Received" },
          colcount: 2,
          colSpan: 1,
          cssClass: "dx-widget",
          // editorOptions: { max: this.today },
        },
        {
          dataField: "monthBilledToClient",
          editorType: "dxTextBox",
          label: { text: "Month Billed To Client" },
          colcount: 2,
          colSpan: 1,
          cssClass: "dx-widget",
          // editorOptions: { max: this.today },
        },
        {
          itemType: "group",
          colCount: 4,
          colSpan: 2,
          items: [
            {
              labelMode: "static",
              dataField: "responsiblePersonId",
              editorType: "dxSelectBox",
              colSpan: 4,
              cssClass: "dx-widget",
              label: { text: "Responsible Person *" },
              editorOptions: {
                items: this.allUsers,
                valueExpr: "id",
                displayExpr: "name",
                required: false,
                searchMode: "contains",
                searchEnabled: true,
                onValueChanged: (e) => {
                  if (e.value) {
                    const selectedUser = this.allUsers.find(u => u.id === e.value);
                    if (selectedUser) {
                      this.requestData.responsiblePerson = selectedUser.name;
                      this.requestData.responsiblePersonId = selectedUser.id;
                      console.log('Person selected:', this.requestData.responsiblePerson);
                      console.log('Person Id:', this.requestData.responsiblePersonId);
                    }
                  }
                },
              },
            },
          ],
          validationRules: [
            { type: "required", message: "Responsible Person is required" },
          ],
        },
        {
          itemType: "group",
          colCount: 4,
          colSpan: 2,
          items: [
            {
              labelMode: "static",
              dataField: "responsibleReviewerId",
              editorType: "dxSelectBox",
              colSpan: 4,
              cssClass: "dx-widget",
              label: { text: "Responsible Reviewer *" },
              editorOptions: {
                items: this.allUsers,
                valueExpr: "id",
                displayExpr: "name",
                required: false,
                searchMode: "contains",
                searchEnabled: true,
                onValueChanged: (e) => {
                  if (e.value) {
                    const selectedUser = this.allUsers.find(u => u.id === e.value);
                    if (selectedUser) {
                      this.requestData.responsibleReviewer = selectedUser.name;
                      this.requestData.responsibleReviewerId = selectedUser.id;
                      console.log('Reviewer selected:', this.requestData.responsibleReviewer);
                      console.log('Reviewer Id:', this.requestData.responsibleReviewerId);
                    }
                  }
                },
              },
            },
          ],
          validationRules: [
            { type: "required", message: "Responsible Reviewer is required" },
          ],
        },
        {
          itemType: "group",
          colCount: 3,
          colSpan: 2,
          items: [
            {
              dataField: "invoiceBorrower",
              editorType: "dxCheckBox",
              label: { text: "Invoice Borrower" },
              colSpan: 1,
              cssClass: "dx-widget",
              editorOptions: {
                value: this.isInvoiceBorrowerChecked,
                onValueChanged: (e) => this.onInvoiceGroupCheckboxChanged(e, 'borrower')
              },
            },
            {
              dataField: "invoiceClient",
              editorType: "dxCheckBox",
              label: { text: "Invoice Client" },
              colSpan: 1,
              cssClass: "dx-widget",
              editorOptions: {
                value: this.isInvoiceClientChecked,
                onValueChanged: (e) => this.onInvoiceGroupCheckboxChanged(e, 'client')
              },
            },
            {
              dataField: "invoiceNone",
              editorType: "dxCheckBox",
              label: { text: "No Invoice" },
              colSpan: 1,
              cssClass: "dx-widget",
              editorOptions: {
                value: this.isInvoiceNoneChecked,
                onValueChanged: (e) => this.onInvoiceGroupCheckboxChanged(e, 'none')
              },
            },
            {
              // Validation proxy field - hidden but validates the group
              dataField: "invoiceValidationProxy",
              colSpan: 3,
              itemType: "simple",
              label: { visible: false },
              editorType: "dxTextBox",
              editorOptions: {
                visible: false,
                value: '',
              },
              validationRules: [
                {
                  type: "custom",
                  message: "At least one invoice option must be selected",
                  validationCallback: (e) => this.validateInvoiceGroup(e),
                  reevaluate: true,
                },
              ],
            },
          ]
        },
        {
          colSpan: 2,
          horizontalAlignment: "center",
          itemType: "simple",
          name: "fileUpload",
          label: {
            text: this.mandatoryFiles ? "Upload Files *" : "Upload Files",
          },
          template: "fileUploadTemplate",
        },
        {
          // work around to bind file upload component to form and validate it
          dataField: "fileUploadProxy",
          colSpan: 2,
          itemType: "simple",
          label: { visible: false },
          editorType: "dxTextBox",
          editorOptions: {
            visible: false,
            value: this.files.length.toString(),
          },
          validationRules: [
            {
              type: "custom",
              message: "At least one file is required",
              validationCallback: (e) => this.onValidateFileAttachments(e),
              reevaluate: true,
            },
          ],
        },
        {
          colSpan: 2,
          horizontalAlignment: "center",
          cssClass: "borrow-submit",
          editorType: "dxButton",
          editorOptions: { text: "Submit", useSubmitBehavior: true },
        },
      ];
    }
    this.formItemsBehaviourSubject$.next(config);
  }

  async onSubmit(e: any)
  {
    e.preventDefault();
    let validationResult = validationEngine.validateGroup("formGroup");
    if (validationResult.isValid)
    {
      try{
        // Get the current form data from the form instance to ensure we have the latest values
        const currentFormData = this.currentFormInstance ? this.currentFormInstance.option('formData') :
        this.requestData;

        const currentData = {
          ...currentFormData,
          monthBilledToClient: currentFormData.monthBilledToClient ?? null,
          dateReceived: currentFormData.dateReceived ?? null,
        };

        // console.log('Request Data:', this.requestData);
        let request: ITaskRequest = new TaskRequest();
        let requestType = this.requestTypes.find((t) => t.name == currentData.requestType);
        request.templateId = requestType.id;
        request.name = currentData.requestType;
        request.referenceName = currentData.loanNumber || '';
        request.referenceType = requestType.referenceType;

        // Extract all dataFields from the current form configuration
        const formDataFields = this.extractDataFieldsFromFormItems(this.formItems);

        // Build submission data with only fields present in the current form
        let submissionData: any = {};

        // Always include requestType
        submissionData.requestType = currentFormData.requestType;

        // Add fields that are in both requestData and current form configuration
        formDataFields.forEach(field => {
          if (currentData.hasOwnProperty(field)) {
            submissionData[field] = currentData[field];
          }
        });
        console.log('Submission Data:', submissionData);
        console.log('Request Data:', this.requestData);
        console.log('Current Form Data:', currentData);
        console.log('Loan Number from currentFormData:', currentData.loanNumber);
        console.log('Reference Name:', request.referenceName);

        // Add responsible person and reviewer data with proper keys
        const requestJsonData: any = { ...currentData };

        if (currentData.responsiblePerson) {
          requestJsonData.responsiblePersonId = currentData.responsiblePersonId;
          requestJsonData.responsiblePerson = currentData.responsiblePerson || '';
        }
        // requestJsonData.responsiblePerson = undefined;

        if (currentData.responsibleReviewer) {
          requestJsonData.responsibleReviewerId = currentData.responsibleReviewerId;
          requestJsonData.responsibleReviewer = currentData.responsibleReviewer || '';
        }

        // Ensure invoice property is set correctly from the component state
        requestJsonData.invoice = this.invoice || 'none';

        // Remove checkbox field names - we only want the invoice property
        requestJsonData.invoiceBorrower = undefined;
        requestJsonData.invoiceClient = undefined;
        requestJsonData.invoiceNone = undefined;
        requestJsonData.invoiceValidationProxy = undefined;
        requestJsonData.fileUploadProxy = undefined;

        let formData : FormData = new FormData()
        formData.append('templateId', request.templateId);
        formData.append('name', request.name);
        formData.append('referenceName', request.referenceName);
        formData.append('requestJsonData', this.removeProxyData(JSON.stringify(requestJsonData)));
        formData.append('referenceType', request.referenceType);
        if (currentData.dateFunded) {
          formData.append('dueDate', currentData.dateFunded.toDateString());
        }

        if(this.isEditable) formData.append('parentId', this.task.parentId)

        this.files.forEach((f) => {formData.append('files', f, f.name)});
        this.isLoading = true;
        const response = await lastValueFrom(this.taskDataService.insertTaskAsFormData(formData));
        sendNotificationMessage(`${response[1].data[0].task.taskId} task created`, this.messageService);
        this.isLoading = false;
        this.formElement.nativeElement.reset();
        this.formElement.nativeElement.submit();
      }
      catch(err: any)
      {
        this.isLoading = false;
        this.loggingService.logError(err, SeverityLevel.Error);
        notify(err.message, 'error', getNotificationTimeout());
      }
    } else {
      console.warn('Validation failed:', validationResult);
      notify('Please fix validation errors before submitting', 'error', getNotificationTimeout());
    }
  }

    /**
   * Recursively extracts all dataField values from form items configuration
   */
  private extractDataFieldsFromFormItems(items: any[]): string[] {
    const dataFields: string[] = [];
    if (!items || !Array.isArray(items)) {
      return dataFields;
    }

    for (const item of items) {
      // Add dataField if it exists and is not a proxy field
      if (item.dataField && !item.dataField.endsWith('Proxy')) {
        dataFields.push(item.dataField);
      }

      // Recursively process nested items (for groups)
      if (item.items && Array.isArray(item.items)) {
        dataFields.push(...this.extractDataFieldsFromFormItems(item.items));
      }
    }
    return dataFields;
  }

  removeProxyData(data: string): string {
    if(data) {
      let json = JSON.parse(data);
      delete json["fileUploadProxy"];
      delete json["invoiceBorrower"];
      delete json["invoiceClient"];
      delete json["invoiceNone"];
      delete json["invoiceValidationProxy"];
      return JSON.stringify(json);
    }
    return "{}";
  }

  onValidateFileAttachments(e: any): boolean {
    if (this.mandatoryFiles && this.files.length == 0) {
      e.isValid = false;
      return false;
    }
    e.isValid = true;
    return true;
  }

  onInvoiceCheckboxChanged(e: any): void {
    this.isInvoiceBorrowerChecked = e.value == 'borrower';
    this.isInvoiceClientChecked = e.value == 'client';
    this.isInvoiceNoneChecked = e.value == 'none';
    // Refresh the form configuration to update drawFee field state
    if (this.currentFormInstance && this.currentRequestType) {
      this.onRequestTypeSelectionChanged({ selectedItem: { name: this.currentRequestType } });
    }
  }

  onInvoiceGroupCheckboxChanged(e: any, fieldName: string): void {
    // Prevent recursive calls when we're programmatically updating checkboxes
    if (this.isUpdatingInvoiceCheckboxes) {
      return;
    }

    // If checkbox is being checked, uncheck the other two
    if (e.value === true) {
      // Set flag to prevent recursive event handling
      this.isUpdatingInvoiceCheckboxes = true;

      // Update component state first
      this.isInvoiceBorrowerChecked = fieldName === 'borrower';
      this.isInvoiceClientChecked = fieldName === 'client';
      this.isInvoiceNoneChecked = fieldName === 'none';
      this.invoice = fieldName;
      this.requestData.invoice = fieldName;

      // Update form data and editors
      if (this.currentFormInstance) {
        const formData = this.currentFormInstance.option('formData') || {};
        formData.invoiceBorrower = this.isInvoiceBorrowerChecked;
        formData.invoiceClient = this.isInvoiceClientChecked;
        formData.invoiceNone = this.isInvoiceNoneChecked;

        // Update other checkboxes without triggering their events
        if (fieldName !== 'borrower') {
          this.currentFormInstance.getEditor('invoiceBorrower')?.option('value', false);
        }
        if (fieldName !== 'client') {
          this.currentFormInstance.getEditor('invoiceClient')?.option('value', false);
        }
        if (fieldName !== 'none') {
          this.currentFormInstance.getEditor('invoiceNone')?.option('value', false);
        }
      }

      // Reset flag after a short delay to allow all updates to complete
      setTimeout(() => {
        this.isUpdatingInvoiceCheckboxes = false;
      }, 0);
    } else {
      // If unchecking, set to none
      this.isUpdatingInvoiceCheckboxes = true;

      this.isInvoiceBorrowerChecked = false;
      this.isInvoiceClientChecked = false;
      this.isInvoiceNoneChecked = true;
      this.invoice = 'none';
      this.requestData.invoice = 'none';

      // Update form data and editors
      if (this.currentFormInstance) {
        const formData = this.currentFormInstance.option('formData') || {};
        formData.invoiceBorrower = false;
        formData.invoiceClient = false;
        formData.invoiceNone = true;

        this.currentFormInstance.getEditor('invoiceBorrower')?.option('value', false);
        this.currentFormInstance.getEditor('invoiceClient')?.option('value', false);
        this.currentFormInstance.getEditor('invoiceNone')?.option('value', true);
      }

      // Reset flag after a short delay
      setTimeout(() => {
        this.isUpdatingInvoiceCheckboxes = false;
      }, 0);
    }

    // Handle drawFee field based on invoice selection
    // Use setTimeout to ensure the form state is fully updated before modifying drawFee
    setTimeout(() => {
      if (this.currentFormInstance) {
        const drawFeeEditor = this.currentFormInstance.getEditor('drawFee');
        if (drawFeeEditor) {
          // Enable drawFee if borrower or client is selected, disable if none
          const shouldEnableDrawFee = this.invoice === 'borrower' || this.invoice === 'client';
          drawFeeEditor.option('disabled', !shouldEnableDrawFee);

          // Clear drawFee value ONLY when none is selected
          if (this.invoice === 'none') {
            drawFeeEditor.option('value', null);
            this.requestData.drawFee = null;
          }
          // When switching between borrower and client, drawFee value is preserved automatically
        }
      }
    }, 0);

    // Revalidate the invoice group
    if (this.currentFormInstance) {
      this.currentFormInstance.getEditor('invoiceValidationProxy')?.option('value',
        this.invoice === 'borrower' || this.invoice === 'client' || this.invoice === 'none' ? 'valid' : ''
      );
    }
  }

  private validateInvoiceGroup(e: any): boolean {
    const isValid = this.invoice === 'borrower' || this.invoice === 'client' || this.invoice === 'none';
    e.isValid = isValid;
    return isValid;
  }

  override async ngOnInit() {
    try{
      this.isLoading = true;
      const requestData = await lastValueFrom(this.taskDataService.getTaskTemplatesByType(this.taskTemplateName));
      this.requestTypes = requestData[1];
      this.files = [];
      await super.ngOnInit();
      await this.getUserData();

      if(this.isEditable)
      {
        // Initialize isInvoiceChecked based on loaded data
        this.isInvoiceBorrowerChecked = this.requestData.invoice === 'borrower';
        this.isInvoiceClientChecked = this.requestData.invoice === 'client';
        this.isInvoiceNoneChecked = this.requestData.invoice === 'none';
        // Initialize invoice checkbox state
        this.invoice = this.requestData.invoice ?? '';
        // console.log(this.notificationData);
      }
      else{
          this.isInvoiceBorrowerChecked = false;
          this.isInvoiceClientChecked = false;
          this.isInvoiceNoneChecked = false;
          // Default to empty for new forms
          this.invoice = '';
      }

      this.isLoading = false;
    }
    catch(err: any) {
      this.loggingService.logError(err, SeverityLevel.Error);
      this.isLoading = false;
      notify(err.message, 'error', getNotificationTimeout());
    }

    this.isEditable = this.task != null ? true : false;
    if(this.isEditable) {
      this.requestData = FormUtils.mapFromTask<TaskBorrowerDrawData>(this.task, TaskBorrowerDrawData);
    } else {
      this.requestData = new TaskBorrowerDrawData();;
    }
  }

}
